import { render, staticRenderFns } from "./countries.vue?vue&type=template&id=63d31977&scoped=true&"
import script from "./countries.vue?vue&type=script&lang=ts&"
export * from "./countries.vue?vue&type=script&lang=ts&"
import style1 from "./countries.vue?vue&type=style&index=1&id=63d31977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d31977",
  null
  
)

export default component.exports